<ng-template #itemTemplate let-item>
    {{ item.identifier || item.description || '' }}
</ng-template>
<ng-template #selectedItemTemplate let-item>
    {{ item.identifier || item.description || '' }}
</ng-template>
